import { useStore } from 'effector-react'
import { $action, mounted, unmounted } from './model'
import * as React from 'react'
import { submitGiftOrderStatus } from '../../details/model'

export const useAction = () => {
  const action = useStore($action)
  const isLoading = useStore(submitGiftOrderStatus.pending)

  React.useEffect(() => {
    mounted()
    return () => unmounted()
  }, [])

  return { action, isLoading }
}
